export class TicketStatusError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'TicketStatusError';
  }
}
